import React, { Component } from "react";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { ListProductReviews } from "../../components/glamclub/ListProductReviews";
import { connect } from "react-redux";
import { ProductDetails } from "./ProductDetails";
import { ProductComments } from "./ProductComments";

class Product extends Component {
  constructor(props) {
    super(props);

    this.state = {
      productDetails: null
      , glampoints: this.props.person.rewardBalance
      , canTrade: false
      , pointsLeftToTrade: 0
    }

    this.getProductDetails = this.getProductDetails.bind(this);
    this.renderTradeOrPointsLeft = this.renderTradeOrPointsLeft.bind(this);
    this.setPointsToTrade = this.setPointsToTrade.bind(this);
  }

  friendlyUrl = (url) => {
    return url.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "-").replace(/^-+|-+$/g, '');
  };

  getProductDetails() {
    const {
      productId,
      productVariantId,
      productVariantName,
      history
    } = this.props;

    ExecuteRequest(
      GlamboxEndpoints.Open.getProductVariantDetail,
      null,
      "GET",
      null,
      { 
        productVariantId: productVariantId 
      },
      (response) => {
        let {
          result,
          statusCode
        } = response;
        
        if (statusCode === 200) {
          let name = this.friendlyUrl(
            result.productVariantName
          );

          if (productVariantName !== name) {
            //history.push("/produtos");
          } {
            this.setState({
              productDetails: result
            });
  
            this.setPointsToTrade();
          }
        } else {
          //history.push("/produtos");
        }
      }
    )
  }

  setPointsToTrade() {
    let { productDetails } = this.state;
    let pointsLeftToTrade = productDetails.tradePoints - this.state.glampoints;

    let newState = {
      canTrade: pointsLeftToTrade <= 0
    }

    if (pointsLeftToTrade > 0) {
      newState.pointsLeftToTrade = pointsLeftToTrade;
    }

    this.setState({newState});
  }

  renderTradeOrPointsLeft() {
    if (this.state.canTrade) {
      return <button onClick={this.tradeProduct}>Trocar</button>
    } else {
      return <div>{this.state.pointsLeftToTrade}</div>
    }
  }

  componentDidMount() {
    const {
      productId,
      productVariantId,
      productVariantName,
      history
    } = this.props;

    if (
      !productId 
      || !productVariantId 
      || !productVariantName 
    ) {
      history.push("/produtos");
    } else {
      this.getProductDetails();
    }
  }

  render() {
    if (this.state.productDetails === null) return null;

    let { productDetails } = this.state;
    let { productId } = productDetails;

    if(!productDetails) return null;
    
    return (
      <div>
        <ProductDetails product={productDetails} />
        <ListProductReviews productId={productId} rating ={productDetails.ratingAverage}></ListProductReviews>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    person: state.person.data.person 
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

Product = connect(mapStateToProps, mapDispatchToProps)(Product);

export { Product };